import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

//- material ui
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

//- local ui
import { getGlobalClasses } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import FormComponent from '../../components/FormComponent';

import CircularProgress from '@material-ui/core/CircularProgress';

//- icons / images
import WarningIconSvg from '../../images/icons/warningIcon.svg';
import ErrorIcon from '@material-ui/icons/Error';
import copyToClipboardSvg from '../../images/icons/copyToClipboard.svg';
import copyToClipboardSuccessSvg from '../../images/icons/copyToClipboardSuccess.svg';
import { green } from '@material-ui/core/colors';

import Note from '../../components/Note';
import Button from '@material-ui/core/Button';
import { red } from '@material-ui/core/colors';
import ShiftTable from './ShiftTable';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 30,
			fontSize: 16,
			borderRadius: '100px',
			padding: '12px 40px',
			textTransform: 'uppercase',
			marginRight: 10,
			lineHeight: '20px',
			height: 70,
		},
		smallWarningIcon: {
			display: 'inline-block',
			width: 28,
			height: 28,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 0,
			marginTop: -6,
		},
		smallErrorIcon: {
			width: 28,
			height: 28,
			color: red[500],
			marginLeft: 0,
			marginTop: -6,
			marginRight: 5,
			verticalAlign: 'middle',
		},

		warningContainer: {
			borderRadius: 5,
			border: '1px solid #ccc',
			padding: 20,
			marginTop: 10,
			marginBottom: 10,
		},

		xContainer: {
			marginTop: 10,
			marginBottom: 40,
		},
		xLabel: {
			fontSize: 24,
			fontWeight: 600,
			marginTop: 15,
			marginBottom: 10,
		},
		xDescription: {
			marginTop: 5,
		},
		xConditions: {
			margin: '17px 0px 2px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#666',
			fontWeight: 900,
			letterSpacing: 2,
		},
		conditionContainer: {
			marginLeft: 0,
		},
		ruleContainer: {
			border: '1px solid #ccc',
			borderRadius: '2px',
			padding: 20,
		},
		orSpacer: {
			margin: '3px 0px',
			color: '#666',
			fontStyle: 'italic',
		},
		hasLineItem: {
			margin: '12px 0px 0px 0px',
			textTransform: 'uppercase',
			fontSize: 13,
			color: '#555',
			//fontWeight : 00,
			letterSpacing: 2,
			marginLeft: 5,
		},
		detailRuleContainer: {
			paddingLeft: 10,
			margin: '5px 5px 5px 5px',
			borderLeft: '2px solid #ddd',
		},

		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		totalStats: {
			fontSize: 18,
			paddingLeft: 10,
			margin: '10px 0',
		},
		totalMatched: {
			fontSize: 24,
			paddingLeft: 10,
			margin: '10px 0',
			marginTop: 30,
			borderBottom: `1px solid #eee`,
		},
		matchContainer: {
			//borderLeft : '2px solid #ccc',
			paddingLeft: 20,
			marginTop: 20,
		},
		list: {
			paddingTop: 10,
		},

		// table classes
		buttonDivider: {
			borderTop: '1px dashed #999',
			marginTop: 5,
			paddingTop: 5,
		},

		textDivider: {
			borderTop: '1px dashed #999',
			marginTop: 10,
			paddingTop: 10,
		},
		eventDivider: {
			borderTop: '1px solid #ccc',
			marginTop: 5,
			paddingTop: 5,
		},

		paddedContainer: {
			paddingBottom: 8,
			paddingTop: 8,
		},
		noteCell: {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			fontWeight: 600,
			marginRight: 3,
		},
		popover: {
			pointerEvents: 'none',
		},
		popoverContainer: {
			padding: 20,
			fontSize: 14,
		},
		popoverShiftContainer: {
			marginBottom: 25,
		},
		popoverShiftTitle: {
			textTransform: 'uppercase',
			color: '#444',
			letterSpacing: '1px',
			borderBottom: '1px solid #ccc',
			marginBottom: 5,
			fontWeight: 800,
		},
		eventNote: {},
		eventDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		copyToClipboardIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${copyToClipboardSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},
		copyToClipboardSuccessIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${copyToClipboardSuccessSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor: 'pointer',
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
	};
};

class ShiftAudit extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			refreshId: 1,
			auditSearchIsPaused: true,
			isSearching: false,
			isClockOutEmployeeDialogOpen: false,
			isUpdateEmployeeDialogOpen: false,
			timeClockShiftForClockOut: undefined,
			isRemoveShiftDialogOpen: false,
			timeClockShiftForRemove: undefined,

			isClearAuditDialogOpen: false,
			timeClockShiftsForClearAudit: undefined,

			popoverIsOpen: false,
			popoverAnchor: undefined,
			popoverTimeClockShifts: [],
		};
	}

	runAudit = () => {
		this.setState({
			refreshId: this.state.refreshId + 1,
			auditSearchIsPaused: false,
		});
	};

	render() {
		const { classes } = this.props;
		const { isRunningAudit } = this.state;
		return (
			<>
				<Paper className={classes.globalMainPaper}>
					<div className={classes.globalMainHeadline}>Run Time Clock Shift Audit</div>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={12} md={10}>
							<Note
								label={`
							Shifts audits are automatically run every 10 minutes and any errors that trigger are
							emailed to the appropriate supervisor. Below you can run the audit manually if you want to see the
							results on this web page or all currently open warnings and errors.
						`}
							/>
						</Grid>

						<Grid item xs={12} style={{ padding: '20px 0px', display: 'flex' }}>
							<div style={{ display: 'flex' }}>
								<Button
									onClick={this.runAudit}
									variant="contained"
									color="primary"
									className={classes.submitButton}
								>
									Run Shift Audit and View ALl Open Warnings and Errors
								</Button>

								{isRunningAudit && (
									<div className={classes.runningSearch}>
										<CircularProgress />
										<span style={{ paddingLeft: 10 }}>Searching...</span>
									</div>
								)}
							</div>
						</Grid>
					</Grid>
				</Paper>

				{!this.state.auditSearchIsPaused && (
					<Paper className={classes.globalMainPaper}>
						<ShiftTable
							method="timeClockAudit.runAudit"
							params={{}}
							paused={this.state.auditSearchIsPaused}
							refreshId={this.state.refreshId}
						/>
					</Paper>
				)}
				{/* {this.renderAuditRunResults()} */}

				<Paper className={classes.globalMainPaper}>
					<div className={classes.globalMainHeadline}>Audit Checks</div>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={12} md={10}>
							<div className={classes.xLabel}>
								<span className={classes.smallWarningIcon} />
								Shift Warnings
							</div>
							<div className={classes.xDescription}>
								Warnings are not emailed to supervisors as they may resolve themselves (employee is
								close to 5 hour first shift and then clocks out). Warnings can become errors if they
								meet an error condition and then it will be escalated to the supervisor.
							</div>
							<div className={classes.xConditions}>Warning Conditions</div>

							<div className={classes.xContainer}>
								<ul>
									<li className={classes.list}>
										Driver clocked in and shift is over 15 and a half hours.
									</li>
									<li className={classes.list}>
										Non-driver currently clocked in and their first shift of the day is almost at 5
										hours.
									</li>
								</ul>
							</div>
						</Grid>

						<Grid item xs={12} sm={12} md={10}>
							<div className={classes.xLabel}>
								<ErrorIcon className={classes.smallErrorIcon} />
								Shift Errors
							</div>
							<div className={classes.xDescription}>
								Shift errors are emailed to the supervisor of the employee on the shift when they
								are detected. The supervisor is in charge of correcting the error and clearing the
								flag.
								<br />
								<strong>Note</strong> : Any shift errors will BLOCK the exporting of shifts to
								exponent HR so need to be fixed first before exporting.
							</div>
							<div className={classes.xConditions}>Error Conditions</div>

							<div className={classes.xContainer}>
								<ul>
									<li className={classes.list}>Driver's shift is over 16 hours.</li>
									<li className={classes.list}>
										Employee is not a driver and they are over (8 / 10 / 12) hours in a single day.
										The 8 / 10 / 12 value is set and can be updated on the user.
									</li>
									<li className={classes.list}>
										Employee is not a driver and their first shift of the day is over 5 hours.
									</li>
									<li className={classes.list}>Shift is under 15 minutes.</li>
								</ul>
							</div>
						</Grid>
					</Grid>
				</Paper>
			</>
		);
	}
}

ShiftAudit.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), AuthUserContainer])(ShiftAudit);
